import { Select, Tag } from 'antd';
import React from 'react';
import {
  FINDING_DISPOSITION_LABELS,
  canSetFindingDisposition,
  findingDispositionLabel,
  findingDispositionOf,
  findingOccurrenceIds,
} from './viewModel';

const OPTIONS = Object.keys(FINDING_DISPOSITION_LABELS).map(value => ({
  value,
  label: FINDING_DISPOSITION_LABELS[value],
}));

const TAG_COLOR = {
  IN_PROGRESS: 'processing',
  RESOLVED: 'success',
  MUTED: 'default',
  DISMISSED: 'default',
};

export const FindingDispositionTag = ({ value, mixed = false }) => {
  if (mixed) return <Tag>Mixed</Tag>;
  return <Tag color={TAG_COLOR[value] || 'default'}>{findingDispositionLabel(value)}</Tag>;
};

export const FindingDispositionSelect = ({
  record,
  disabled,
  loading,
  onChange,
}) => {
  const writable = canSetFindingDisposition(record);
  const mixed = Boolean(record?.dispositionMixed);
  const value = mixed ? undefined : (findingDispositionOf(record) || 'UNTRIAGED');
  if (!writable || disabled) {
    return writable || mixed || findingDispositionOf(record)
      ? <FindingDispositionTag value={findingDispositionOf(record)} mixed={mixed} />
      : '—';
  }
  return (
    <Select
      aria-label="Finding status"
      size="small"
      value={value}
      placeholder="Mixed"
      loading={loading}
      options={OPTIONS}
      style={{ width: 128 }}
      onClick={event => event.stopPropagation()}
      onChange={next => onChange?.(findingOccurrenceIds(record), next)}
    />
  );
};
